import React, { Component } from 'react';
import HeaderTwo from '../../components/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import AboutUs from '../../components/AboutUs';
import Punchmuka from '../../components/Punchmuka';
import TabBox from './../../components/TabBox';
import TestimonialSlider from '../../components/TestimonialSlider';
import FaqEvent from '../../components/FaqEvent';
import Footer from '../../components/Footer';
import { Styles } from "./styles/punchamuka";

class Punchamukha extends Component {

    render() {
        return (
            <Styles>
                {/* Main Wrapper */}
                <div className="main-wrapper punchamuka-page">

                    {/* Header 2 */}
                    <HeaderTwo />

                    {/* Breadcroumb */}
                    <BreadcrumbBox title="Panchamuka Shikashana" />

                    {/* About Area */}
                    {/* <AboutUs /> */}

                    {/* Icon Box Area */}
                    <Punchmuka />

                    {/* Tab Section */}
                    {/* <TabBox /> */}

                    {/* Testimonial Slider */}
                    {/* <TestimonialSlider /> */}

                    {/* Faq & Event Area */}
                    {/* <FaqEvent /> */}

                    {/* Footer 2 */}
                    <Footer />

                </div>
            </Styles>
        )
    }
}

export default Punchamukha